import { ProductsService } from './products.service';

export default angular
  .module('sfMobile.services.products', ['sfMobile.services.crud'])
  .service('productsService', ProductsService).name;
